import { useMemo } from 'react';
import { Button } from 'react-bootstrap';

import { ButtonSplitGroup } from '@components/Buttons';
import { BootstrapTable } from '@components/Table/Table';

export const ProductSheetTable = ({
  data,
  productLocation,
  setTitle,
  setProductLocation,
}) => {
  const renderDownloadCell = ({ row }) => {
    const {
      description,
      location,
      csv_location: csvLocation,
      pdf_location: pdfLocation,
    } = row.original;
    return (
      <ButtonSplitGroup>
        {location && (
          <Button
            size="sm"
            variant="didxl"
            onClick={() => {
              if (productLocation === location) {
                setTitle('');
                setProductLocation(null);
                return;
              }
              setTitle(description);
              setProductLocation(location);
            }}
          >
            Display
          </Button>
        )}
        {pdfLocation && (
          <Button
            size="sm"
            variant="didxl"
            as="a"
            href={pdfLocation}
            target="_blank"
          >
            PDF
          </Button>
        )}
        {csvLocation && (
          <Button size="sm" variant="didxl" as="a" href={csvLocation}>
            CSV
          </Button>
        )}
      </ButtonSplitGroup>
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Document',
        accessor: 'description',
      },
      {
        Header: 'Download',
        accessor: 'actions',
        Cell: renderDownloadCell,
      },
    ],
    [productLocation]
  );
  return (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, borderless: true })}
    />
  );
};
